import { render } from "./ContactoList.vue?vue&type=template&id=3f6dd040"
import script from "./ContactoList.vue?vue&type=script&lang=js"
export * from "./ContactoList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__